import React from "react";
import { Redirect } from "react-router-dom";
import firebase from "firebase";

const Logout = props => {
  firebase.auth().signOut();

  return (
    <Redirect
      to={{
        pathname: "/"
      }}
    />
  );
};

export default Logout;



// WEBPACK FOOTER //
// ./src/containers/Logout.js